/**
 * Analyst / account manager / manager screens (lazy chunks).
 * Owned by the "desk screens" work stream — only this file changes for their routes.
 * The customer's secure report link (/r/:token) is public and is routed in
 * features/public-report/PublicRouteSwitch.tsx, outside the sign-in gate.
 */
import type { RouteObject } from '../lib/router';
import { lazyPage } from './lazy';

const review = () => import('../features/review/ReviewQueuePage');
const surveyReview = () => import('../features/review/SurveyReviewPage');
const findings = () => import('../features/findings/FindingsPage');
const overdue = () => import('../features/overdue/OverduePage');
// recharts lives only in this chunk.
const dashboard = () => import('../features/dashboard/DashboardPage');
const safety = () => import('../features/safety/ZeroHarmCommandPage');
const events = () => import('../features/events/EventsPage');
const eventDetail = () => import('../features/events/EventDetailPage');
const insights = () => import('../features/insights/InsightsPage');
const summaries = () => import('../features/summaries/SummariesPage');

export const DESK_ROUTES: RouteObject[] = [
  { path: '/review', element: lazyPage(review, 'ReviewQueuePage') },
  { path: '/surveys/:id/review', element: lazyPage(surveyReview, 'SurveyReviewPage') },
  { path: '/findings', element: lazyPage(findings, 'FindingsPage') },
  // Condition Management opens as a side panel over the list.
  { path: '/findings/:id', element: lazyPage(findings, 'FindingsPage') },
  { path: '/overdue', element: lazyPage(overdue, 'OverduePage') },
  { path: '/dashboard', element: lazyPage(dashboard, 'DashboardPage') },
  { path: '/safety', element: lazyPage(safety, 'ZeroHarmCommandPage') },
  { path: '/events', element: lazyPage(events, 'EventsPage') },
  { path: '/events/:id', element: lazyPage(eventDetail, 'EventDetailPage') },
  { path: '/insights', element: lazyPage(insights, 'InsightsPage') },
  { path: '/summaries', element: lazyPage(summaries, 'SummariesPage') },
  { path: '/summaries/:id', element: lazyPage(summaries, 'SummaryDetailPage') },
];
